import axios from 'axios';

export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    async retrieveContent(context, data) {
      try {
        const config = { withCredentials: true };
        if (data && data.sharedToken) config.headers = { Authorization: data.sharedToken };
        const content = await axios.get(`/autodesk/data-management/data-management/projects/${data.projectId}/folders/${data.folderId}`, config);
        return content.data;
      } catch (error) {
        throw error;
      }
    },
    async retrieveInfoById(context, data) {
      try {
        const config = { withCredentials: true };
        if (data && data.sharedToken) config.headers = { Authorization: data.sharedToken };
        const content = await axios.get(`/autodesk/data-management/data-management/projects/${data.projectId}/folders/${data.folderId}/info`, config);
        return content.data;
      } catch (error) {
        throw error;
      }
    },
  },
};
